import {
  mapPersonType,
  PersonJobType,
  useFindPersonDetailsSuspense,
} from '@api';
import { ManageTableProvider, UseManageTableReturnType } from '@common';
import { Stack } from '@mantine/core';
import { PreviousShows, UnconfirmedShows, UpcomingShows } from './components';

type TourRepSelfPromotePropsType = {
  personId: string;
  unconfirmedShows: PersonJobType[];
  upcomingShows: PersonJobType[];
  previousShows: PersonJobType[];
  isPendingUnconfirmedShows: boolean;
  isPendingUpcomingShows: boolean;
  isPendingPreviousShows: boolean;
  upcomingTableMethods: UseManageTableReturnType;
  previousTableMethods: UseManageTableReturnType;
};

export const TourRepSelfPromote: React.FC<TourRepSelfPromotePropsType> = ({
  personId,
  unconfirmedShows,
  upcomingShows,
  previousShows,
  isPendingUnconfirmedShows,
  isPendingUpcomingShows,
  isPendingPreviousShows,
  upcomingTableMethods,
  previousTableMethods,
}) => {
  const { data: personDetails } = useFindPersonDetailsSuspense(personId, {
    query: { select: (data) => mapPersonType(data.data) },
  });

  return (
    <Stack py="md">
      <UnconfirmedShows
        unconfirmedShows={unconfirmedShows}
        personId={personId}
        isPending={isPendingUnconfirmedShows}
        assignedUserId={personDetails.userId}
      />
      <ManageTableProvider {...upcomingTableMethods}>
        <UpcomingShows
          upcomingShows={upcomingShows}
          isPending={isPendingUpcomingShows}
        />
      </ManageTableProvider>
      <ManageTableProvider {...previousTableMethods}>
        <PreviousShows
          previousShows={previousShows}
          isPending={isPendingPreviousShows}
        />
      </ManageTableProvider>
    </Stack>
  );
};
